import type { FC } from 'react'
import { isDate, format, secondsToMilliseconds } from 'date-fns'

type CreatedAtCellProps = {
  value: Date
}

export const CreatedAtCell: FC<CreatedAtCellProps> = (props) => {
  const dateValue = props.value as
    | Date
    | {
        _seconds: number
        _nanoseconds: number
      }
    | undefined

  if (!dateValue) return '-'

  if (!isDate(dateValue)) {
    if (dateValue?._seconds) {
      return format(secondsToMilliseconds(dateValue._seconds), 'd MMM yy')
    }

    return '-'
  }

  return format(new Date(dateValue as Date), 'd MMM yy')
}
